import { useState, useCallback, useEffect } from 'react';

const useDrag = ({ position, minPosition, maxPosition, onChange, isDisabled }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [currentPosition, setCurrentPosition] = useState(position || minPosition);
  const [initialOffset, setInitialOffset] = useState(0);
  const [initialClientPosition, setInitialClientPosition] = useState(0);
  const handleMouseMove = useCallback((event) => {
    if (isDragging) {
      let position2;
      if (event.touches) {
        const touch = event.touches[0];
        if (touch) {
          position2 = touch.clientX;
        }
      } else {
        position2 = event.clientX;
      }
      const currentPosition2 = initialOffset + position2 - initialClientPosition;
      if (currentPosition2 > minPosition && currentPosition2 < maxPosition) {
        onChange == null ? void 0 : onChange(currentPosition2);
        setCurrentPosition(currentPosition2);
      }
    }
  }, [isDragging, onChange, initialOffset, maxPosition, minPosition, initialClientPosition]);
  const handleDragEnd = useCallback(() => {
    if (isDragging) {
      setIsDragging(false);
    }
  }, [isDragging]);
  const handleMouseDown = (event) => {
    if (isDisabled)
      return;
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
    setInitialClientPosition(event.clientX);
    setInitialOffset(currentPosition);
  };
  const handleTouchStart = (event) => {
    if (isDisabled)
      return;
    setIsDragging(true);
    if (event.touches) {
      const touch = event.touches[0];
      if (touch) {
        setInitialClientPosition(touch.clientX);
      }
    }
    setInitialOffset(currentPosition);
  };
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchmove", handleMouseMove);
    window.addEventListener("mouseup", handleDragEnd);
    window.addEventListener("touchend", handleDragEnd);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("mouseup", handleDragEnd);
      window.removeEventListener("touchend", handleDragEnd);
    };
  }, [handleMouseMove, handleDragEnd]);
  return {
    currentPosition,
    isDragging,
    handleMouseDown,
    handleTouchStart
  };
};

export { useDrag };
//# sourceMappingURL=useDrag.es.js.map
